// @ts-nocheck
import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { IoSettingsOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { GetTodaysDateINdmy } from "../../../../CommonFunction/GetTodaysDate";
import { IsoToDateWithoutTime } from "../../../../CommonFunction/IsoDateTime";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import {
  DeleteSalesBill,
  getDefaultVoucherSeries,
  getFormSectionsAndFields,
  GetRefrenceWithTransactionId,
  GrtPreferenceByFormKey,
  LOCK_VOUCHER,
  NewReferencesOfAccount,
  nextBillNo,
  SearchInvoice,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import {
  createVoucher,
  editVoucher,
  getsalesBillById,
} from "../../../../Utils/VouchersQueryAndMutation/VoucherQueries";
import extractCustomFields from "../../../CommonFunction/extractCustomFields";
import processFormDataWithCustomFields from "../../../CommonFunction/processFormDataWithCustomFields";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import Button from "../../Button/Button";
import { Confirm } from "../../Confirmation/Confirm";
import { FormConfiguration } from "../../FormConfiguration/FormConfiguration";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { handleFormReset, updateSingleField, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import { consolidateTransactions, createTransaction, getTotalAmount, prepareReferenceData } from "../../InvoceComponents/RelatedFunctions";
import { FormulaTable } from "../../InvoceComponents/SalesBillFormulaTable";
import { SalesItemTable } from "../../InvoceComponents/SalesItemTable";
import Loading from "../../Loading/Loading";
import { useModalContext } from "../../Reactportal/ModalContext";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import InvoiceNumberConfiguration from "../InvoiceNumberConfiguration/InvoiceNumberConfiguration";
import { AmountDetails, initialRef, TransactionTypeDetails } from "../ReferenceSection/Reference.config";
import { ReferenceModal } from "../ReferenceSection/ReferenceModal";
import "./AddPurchaseBill.scss";
import {
  data,
  fields1,
  fields2,
  Purchase_Bill_Documents,
  PurchaseBillConfiguration,
  PurchaseInvoiceNumberConfig,
} from "./AddPurchaseBillConfig";
import { autoSetReference } from "../../InvoceComponents/autoSetReference";

interface formulType {
  Account_Name?: string;
  Account_ID?: string;
  Name?: string;
  At_Percentage?: number;
  row_id?: string;
  Amount?: number;
  Expense_Account?: any;
  Transaction_Type?: string;
  Add_Deduct?: String;
}

const AddPurchaseBill = ({ show, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
  const Form_Key = "Purchase_Bill";
  const formRef = useRef({});
  const operationType = TypeOfPortal === "Copy" ? "Add" : TypeOfPortal;
  const { pushModal, popModal } = useModalContext();
  const ReferenceData = useSelector((store: any) => store.TableDataReducer.tableData) || { 1: {} };
  const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);
  const fielddataRedux = useSelector((store: any) => store.UniqueTableReducer);
  const dispatch = useDispatch();

  const fielddata = fielddataRedux?.Purchase_Bill?.Selected_Row || fielddataRedux?.Account_Vouchers?.Selected_Row || fielddataRedux?.Transaction_Checks?.Selected_Row;
  let Party = FormDataFromRedux?.MasterData?.[Form_Key]?.Party;
  let HSN_Code = FormDataFromRedux?.MasterData?.[Form_Key]?.HSN_Code;

  const [TaxType, setTaxType] = useState("");
  const [toggle, settoggle] = useState(show ? show : false);
  const [openRef, setOpenRef] = useState(false);
  const [Note, setNote] = useState("");
  const [allFieldsData, setAllFieldsData] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [lastModified, setLastModified] = useState({ fieldName: "", rowId: "" });
  const [Total, setTotal] = useState(0);
  const [Formula, setFormula] = useState<formulType[]>([]);
  const [formErrors, setFormErrors] = useState({});
  const [RefRows, setRefRows] = useState<any>({ 1: {} });
  const [fields, setfields] = useState([...data]);
  const [isFirstLoad, setFirstLoad] = useState(false);
  const [FormData, setFormData] = useState({});
  const [openSetting, setOpenSetting] = useState(false);
  const [OpenBookCodeSet, setOpenBookCodeSet] = useState(false);
  const [InputFields, setInputFields] = useState([]);
  const [tableData, setTableData] = useState({
    [Math.random() * 10]: fields1,
  });
  const [selectedOption, setSelectedOption] = useState({
    selectedRadioOption: "TDSMaster",
    TDSTCSData: "",
    TDSTCSRate: "",
    TDSTCSAmount: "",
  });
  const [cusFieldShow, setcusFieldShow] = useState(false);
  const [storeCustomFields, setStoreCustomFields] = useState([]);
  // Q & M
  const [GetInvoiceData] = useLazyQuery(SearchInvoice, {
    fetchPolicy: "network-only",
    variables: {
      Invoice_Type: Form_Key,
    },
  });

  const [getDataByKey] = useLazyQuery(GrtPreferenceByFormKey, {
    variables: {
      Form_Key: Form_Key,
    },
    fetchPolicy: "network-only",
  });

  const [getDefaultBillNo] = useLazyQuery(getDefaultVoucherSeries, {
    fetchPolicy: "network-only",
  });

  const [GetNextBillNo] = useLazyQuery(nextBillNo, {
    fetchPolicy: "network-only",
  });

  const [GetDataById, { loading: DataLoading }] = useLazyQuery(getsalesBillById, {
    fetchPolicy: "network-only",
  });

  const [DeletingData, { loading: deleteLoading }] = useMutation(DeleteSalesBill, {
    fetchPolicy: "network-only",
  });

  const [getFormSectionAndFields, { loading: getFormSectionAndFieldsLoading }] = useLazyQuery(
    getFormSectionsAndFields,
    {
      variables: {
        key: Form_Key,
      },
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        console.log(data);
        setInputFields(data?.formSectionAndFields);
      },
    }
  );

  const [getReference] = useLazyQuery(GetRefrenceWithTransactionId, {
    fetchPolicy: "network-only",
  });
  const [CreatingData, { loading: createLoading }] = useMutation(createVoucher);
  const [EditingData, { loading: EditLoading }] = useMutation(editVoucher);
  const [lockTheEntry, { loading: lockSalesBillLoading }] = useMutation(LOCK_VOUCHER);
  const SalesBillLoadingState = createLoading || EditLoading || deleteLoading || DataLoading;

  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, FormData, selectedRows);
  const { executeOperation } = useSubmitOperation();

  let newFormData = { ...FormData };
  console.log(ReferenceData)
  const mutationFunctions = {
    CreatingData,
    EditingData,
    DeletingData,
    lockTheEntry,
  };

  useEffect(() => {
    getFormSectionAndFields();
  }, []);

  useEffect(() => {
    const fields = extractCustomFields(InputFields);
    setStoreCustomFields(fields);
  }, [InputFields]);

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key)
    }
  }, []);



  const getNetBillNumber = (bookCode = "") => {
    console.log(bookCode);
    getDefaultBillNo({
      variables: {
        FormKey: Form_Key,
        bookCode,
      },
    }).then(({ data }) => {
      console.log(data);
      let defaultNo = data?.getAutoVoucheSeries;
      console.log(defaultNo, "defaultNo")
      if (defaultNo.Prefix) {
        dispatch({
          type: "StoreMasterData",
          payload: {
            formkey: Form_Key,
            data: { Voucher_Series: defaultNo },
          },
        });
        updateSingleField(
          formRef,
          "Invoice_No",
          `${defaultNo.Prefix}${defaultNo.Bill_No}${defaultNo.Sufix ? defaultNo.Sufix : ""}`
        );

        setFormData((prev) => ({
          ...prev,
          Voucher_Series: `${defaultNo.Prefix}***${defaultNo.Sufix ? defaultNo.Sufix : ""}`,
          Bill_No: defaultNo.Bill_No,
        }));
      }
    });
  };

  const getDefaultValues = () => {
    getNetBillNumber();
    getDataByKey({
      variables: {
        Form_Key,
      },
    }).then(({ data }) => {
      let obj = { ...data?.User_Preferences_By_Form_Key?.configurationData };

      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey: "Preference",
          data: { Default_Voucher_Series: obj.Default_Voucher_Series },
        },
      });
      obj.Default_Voucher_Series = obj.Default_Voucher_Series?.Search_Value;
      setFormData((prev) => ({
        ...prev,
        ...obj,
      }));
    });
  };

  useEffect(() => {

    if (InputFields.length) {
      if (TypeOfPortal === "Add" && !isFirstLoad) {
        getDefaultValues();
        updateValueForm(formRef, {
          Date: GetTodaysDateINdmy(),
          CashOrDebit: "Credit",
          RCM: false,
        });
        setFirstLoad(true);
      } else if (fielddata?._id) {
        GetDataById({
          variables: {
            getSalesBillByIdId: fielddata["Voucher_Id"] || fielddata?._id,
          },
        }).then(({ data }) => {
          let obj = { ...data?.GetSalesBillById };


          obj.RCM = obj.RCM == "YES" ? true : false;
          obj.Date = IsoToDateWithoutTime(obj.Date);
          obj.Doc_Date = IsoToDateWithoutTime(obj.Doc_Date);
          let FormulaArray: any = [];
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_Key,
              data: {
                Party: {
                  ...obj.Party,
                  Account_Balance_Id: obj.Party?._id,
                  Balance_Method: obj?.Party?.AccountData?.Balance_Method,
                  _id: obj?.Party?.AccountData?._id,
                },
                Tax_Group: { ...obj?.Tax_Group, Search_Value: obj?.Tax_Group?.Tax_Group_Name },
                Voucher_Series: { ...obj?.Voucher_Series_Data, Search_Value: obj?.Voucher_Series_Data?.Value },
                Default_Voucher_Series: obj?.Default_Voucher_Series,
                Sales_Account: { ...obj?.Sales_Account, Account_Balance_Id: obj?.Sales_Account?._id },
              },
            },
          });
          let Party = { ...obj.Party }
          let tabelDataObj = {};
          obj.Party = obj?.Party?.Search_Value;
          obj.Default_Voucher_Series = obj?.Default_Voucher_Series?.Search_Value;
          obj.Tax_Group = obj?.Tax_Group?.Tax_Group_Name;
          obj.Voucher_Series = obj?.Voucher_Series_Data?.Value;

          obj.Sales_Account = obj?.Sales_Account?.Search_Value;

          if (TypeOfPortal === "Copy") {

            getNetBillNumber(data?.GetSalesBillById?.Default_Voucher_Series?._id);
          }
          obj?.TransactionsData?.forEach((el) => {

            let key = Math.random() * 10;

            if (el.Entry_For === "Sales") {

              let data: any = {
                HSN_Code: { ...el?.HSN_Code, Search_Value: el?.HSN_Code?.Code },
                Tax_Group: { ...el?.Tax_Group, Search_Value: el?.Tax_Group?.Tax_Group_Name },
                Account: { ...el?.Account, Account_Balance_Id: el?.Account._id },
              };
              let Fields = [...fields2];
              if (obj?.Voucher_Mode === "Item Invoice") {
                data.Stock_Item = el?.Stock_Item;
                Fields = [...fields1];
              }

              if (obj.Tax === "Common") {
                Fields = Fields?.filter((el) => !el.name.includes("Tax_Group"));
              }
              if (obj.Sales_Account_Selection === "Common") {
                Fields = Fields?.filter((el) => !el.name.includes("Account"));
              }

              let updatedData = Fields?.map((row) => {

                let column = el[row.name];

                if (typeof column === "object") {
                  return { ...row, value: column?.Search_Value };
                }
                return { ...row, value: column };
              });

              tabelDataObj[key] = updatedData;
              dispatch({
                type: "StoreMasterDataForRow",
                payload: {
                  formkey: Form_Key,
                  rowId: key,
                  data,
                },
              });
            } else if (el.Entry_For === "Tax") {
              let obj = {
                Expense_Account: el.Account,
                Input_Account: el.Account,
                Amount: el.Amount,
                Name: el.Name,
                Rate: el.Rate,
                Transaction_Type: el.Transaction_Type,
                Tax_Type: el.Tax_Type,
              };
              FormulaArray.push(obj);
            }
            else if (el.Entry_For === "TDSTCS") {
              setSelectedOption({

                TDSTCSData: el.TDS_TCS_Master?.Tax_Name,
                TDSTCSAmount: el.Amount,
                TDSTCSRate: el.Tax_Rate,
                selectedRadioOption: el.Name
              })
              dispatch({
                type: "StoreMasterData",
                payload: {
                  formkey: Form_Key,
                  data: {
                    TDSTCS: el.TDS_TCS_Master
                  }
                }
              })
            }
          });

          setLastModified({ fieldName: "Tax_Group", rowId: "" });
          setNote(obj.Narration);

          setAllFieldsData(obj);
          setFormData((prev) => ({
            ...prev,
            ...obj,
          }));

          if (obj?.customFieldData && typeof obj.customFieldData === "object") {
            Object.entries(obj.customFieldData).forEach(([key, value]) => {
              obj[key] = value ?? ""; // Assign value or empty string if undefined/null
            });
          }
          updateValueForm(formRef, obj);

          setTableData(tabelDataObj);
          setFormula(FormulaArray);

          obj.Transactions?.map((el) => {

            if (TypeOfPortal === "Edit" && el.Transaction_Type === "Credit" && (Party.AccountData?.Balance_Method === "Bill By Bill" || Party.AccountData?.Balance_Method === true)) {
              getReference({
                variables: {
                  TransactionId: el._id,
                },
              }).then((res) => {
                let updatedTransRef = {};

                res?.data?.getRefrenceWithTransactionId?.map((el) => {
                  let InitialRef = [
                    ...initialRef.slice(0, -1),
                    AmountDetails,
                    TransactionTypeDetails,
                    initialRef[initialRef.length - 1],
                  ];
                  let singleRef = InitialRef.map((item: any) => {
                    if (item.name === "Particular") {
                      item = { ...item, NewRef_Id: el["NewRef_Id"] };
                    }
                    if (item.name === "RefDate") {
                      return { ...item, value: IsoToDateWithoutTime(el[item.name]) };
                    }
                    return { ...item, value: el[item.name] };
                  });
                  updatedTransRef = {
                    ...updatedTransRef,
                    [Math.random() * 10]: singleRef,
                  };
                });
                console.log({
                  [1]: updatedTransRef,
                })
                setRefRows({
                  [1]: updatedTransRef,
                });
              });
            }
          });
          delete obj.TransactionsData;
          delete obj.Transactions;
        });
      }
    }
  }, [fielddata, InputFields]);

  useEffect(() => {
    setSelectedRows(fielddataRedux?.Purchase_Bill?.Selected_Rows || []);
  }, [fielddataRedux]);

  useEffect(() => {
    dispatch({ type: "tableData", payload: RefRows });
  }, [RefRows]);

  useEffect(() => {
    // Get the DOM elements
    const settings = document.getElementsByClassName("InputEditIcon");


    // Function to be called on click
    const handleClickSettings = () => {

      setOpenBookCodeSet(true);
    };

    // Attach the click event listener to each element
    Array.from(settings).forEach((element) => {

      element.addEventListener("click", handleClickSettings);
    });

    // Clean up the event listeners when the component unmounts
    return () => {
      Array.from(settings).forEach((element) => {
        element.removeEventListener("click", handleClickSettings);
      });
    };
  }, [InputFields]);

  // useEffect(() => {
  //   const isRelevantFieldModified =
  //     ["Tax_Group", "Item_Value", "Quantity", "Amount", "Stock_Item"].includes(lastModified.fieldName) ||
  //     lastModified.fieldName.includes("Tax_Group");
  //   let REF = { ...RefRows[1] };
  //   let total = getTotalAmount(Formula);
  //   console.log(JSON.stringify(RefRows[1]) === JSON.stringify({}))
  //   if (
  //     total &&
  //     isRelevantFieldModified &&
  //     FormData?.Party &&
  //     (JSON.stringify(RefRows[1]) === JSON.stringify({})) &&
  //     (Party?.Balance_Method === "Bill By Bill" || Party?.Balance_Method === true)
  //   ) {
  //     let InitialRef = [
  //       ...initialRef.slice(0, -1),
  //       AmountDetails,
  //       TransactionTypeDetails,
  //       initialRef[initialRef.length - 1],
  //     ];

  //     let singleRef = InitialRef.map((item: any) => {
  //       if (item.name === "Particular") {
  //         return { ...item, value: FormData?.Invoice_No || "" };
  //       }
  //       if (item.name === "Type") {
  //         return { ...item, value: `New Reference` };
  //       }
  //       if (item.name === "Amount") {
  //         return { ...item, value: total };
  //       }
  //       if (item.name === "TransactionType") {
  //         return { ...item, value: "Credit" };
  //       }
  //       if (item.name === "RefDate") {
  //         return { ...item, value: GetTodaysDateINdmy() };
  //       }
  //       return item;
  //     });

  //     let updatedTransRef = {
  //       [Math.random() * 10]: singleRef,
  //     };

  //     setRefRows({
  //       [1]: updatedTransRef,
  //     });
  //   }
  // }, [
  //   lastModified,
  //   FormData?.Tax_Group,
  //   FormData?.Party,
  //   FormDataFromRedux?.MasterData[Form_Key],
  //   tableData,
  //   Formula,
  //   FormData?.RCM,
  //   FormData?.Invoice_No,
  // ]);


  useEffect(() => {
    console.log(RefRows, "kkkkkkkk", ReferenceData)
    let obj = { ...ReferenceData }
    autoSetReference({
      ReferenceData,
      setRefRows,
      lastModified,
      Formula,
      getTotalAmount,
      FormData,
      Party,
      initialRef,
      AmountDetails,
      TransactionTypeDetails,
      TransactionType: "Credit"
    });
  }, [
    lastModified,
    FormData?.Tax_Group,
    FormData?.Party,
    Formula,
    FormData?.RCM,
    FormData?.Invoice_No,
    FormData?.Ref_No,
  ]);

  const HanldeChangeonForm = (values) => {
    console.log(values, "Formdata_without_redux1");
    setFormData((prev) => ({
      ...prev,
      ...values,
    }));
  };
  const handleErrorsChange = (newErrors) => {
    // debugger;
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };
  //to check errors and throw the error submit will not
  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };
  const submit = (closeAction) => {
    let Data = {
      ...variables[TypeOfPortal == "Add" ? "createInput" :
        "userInput"
      ]
    }
    Data = processFormDataWithCustomFields(newFormData, storeCustomFields);

    setFirstLoad(false);
    let References = prepareReferenceData(ReferenceData)

    References = References.filter((el) => el);


    let tableDataTransaction = createTransaction(tableData, "Sales", FormDataFromRedux, Data, Form_Key, "Input_Account");


    let formulaTransaction = createTransaction(Formula, "Tax", FormDataFromRedux, {}, Form_Key, "Input_Account");


    let transactions: any[] = [];
    let table: any[] = [];
    function updateTransactions(transaction) {
      if (transaction?.TransactionArray) {
        transactions = [...transactions, ...transaction.TransactionArray];
      }
      if (transaction?.updatedData) {
        table = [...table, ...transaction.updatedData];
      }
    }

    let TDSTCSData = {
      Name: selectedOption?.selectedRadioOption,
      TDS_TCS_Master: FormDataFromRedux?.MasterData?.[Form_Key]?.["TDSTCS"]?._id,
      Tax_Rate: selectedOption?.TDSTCSRate,
      Amount: selectedOption?.TDSTCSAmount,
      Entry_For: "TDSTCS"
    };

    let TDSTCSDataTransaction = {
      Transaction_Type: "Credit",
      Amount: selectedOption?.TDSTCSAmount,
      Account_ID: FormDataFromRedux?.MasterData?.[Form_Key]?.["TDSTCS"]?.Payable_Account?._id
    };
    updateTransactions(tableDataTransaction);
    updateTransactions(formulaTransaction);
    let Party = FormDataFromRedux?.MasterData?.[Form_Key]?.Party;
    transactions = [...transactions]
    transactions = [...transactions, ...(selectedOption?.TDSTCSData ? [TDSTCSDataTransaction] : [])]
    transactions = consolidateTransactions(transactions, References, Party);
    // Data.TransactionsData = [...table];
    Data.TransactionsData = [...table, ...(selectedOption?.TDSTCSData ? [TDSTCSData] : [])];
    //
    Data.Voucher_Series = FormDataFromRedux?.MasterData?.[Form_Key]?.Voucher_Series?._id;
    Data.Default_Voucher_Series = FormDataFromRedux?.MasterData?.[Form_Key]?.Default_Voucher_Series?._id;
    Data.Party = Party?.Account_Balance_Id;
    Data.Entry_Type = "Purchase Bill";
    Data.Voucher_Type = "Purchase Bill";
    Data.Narration = Note;
    Data.RCM = Data.RCM ? "YES" : "NO";
    // if (Data?.Date) {
    //   Data.Date = convertToISO(Data.Date);
    // }
    // if (Data?.Doc_Date) {
    //   Data.Doc_Date = convertToISO(Data.Doc_Date);
    // }
    if (Data?.Sales_Account) {
      Data.Sales_Account = FormDataFromRedux?.MasterData?.[Form_Key]?.Sales_Account?.Account_Balance_Id;
    }
    if (Data?.Tax_Group) {
      Data.Tax_Group = FormDataFromRedux?.MasterData?.[Form_Key]?.Tax_Group?._id;
    } else if (Data) {
      delete Data.Tax_Group;
    }
    //

    if (TypeOfPortal !== "Add") {
      delete Data._id;
      delete Data.__typename;
      delete Data.Voucher_Series_Data;
    }
    variables[TypeOfPortal == "Add" ? "createInput" :
      "userInput"
    ] = Data
    variables.Transactions = transactions;
    const mutationFunction = getMutationFunction(operationType, mutationFunctions);

    const executeOperationFunction = () => {
      return executeOperation({
        operationType,
        data: variables[TypeOfPortal == "Add" ? "createInput" :
          "userInput"
        ],
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        EditRefresh: false,
        PageName: Form_Key,
      });
    };
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      Form_Key,
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: () => {
        clearsForm();
        let defaultVar = FormData;
        handleFormReset(formRef);
        updateValueForm(formRef, {
          Voucher_Mode: defaultVar?.Voucher_Mode,
          Tax: defaultVar.Tax,
          Date: GetTodaysDateINdmy(),
          CashOrDebit: "Credit",
          RCM: false,
          Sales_Account_Selection: defaultVar.Sales_Account_Selection,
          Default_Voucher_Series: defaultVar?.Default_Voucher_Series,
        });
        setSelectedOption({
          selectedRadioOption: "TDSMaster",
          TDSTCSData: "",
          TDSTCSRate: "",
          TDSTCSAmount: "",
        });
        getDefaultValues()
        // Closeformfunction();
      },
      onSuccess: () => {
        dispatch({ type: "Refetch", payload: true });
      },
      onError: (error) => {
        ErrorToast(`${error.message}`);
      },
    });
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };

  const clearsForm = () => {
    handleFormReset(formRef);

    const firstKey = Object.keys(tableData)[0];
    let filterData = tableData[firstKey]?.map((el) => ({ ...el, value: "" }));

    setTableData({ [Math.random() * 10]: [...filterData] });
    setFormula([]);
    setNote("");
    dispatch({ type: "CleartableData" });
    setSelectedOption({
      selectedRadioOption: "TDSMaster",
      TDSTCSData: "",
      TDSTCSRate: "",
      TDSTCSAmount: "",
    });
    ClearSpecificForm(dispatch, Form_Key);
  };

  const Closeformfunction = () => {
    clearsForm();
    // popModal(Form_Key);
    ParentPortalCloseFunction();
    settoggle(false);
  };

  const OpenReference = () => {
    setOpenRef(true);
    let sum: number = getTotalAmount(Formula);
    setTotal(sum);
  };

  const HandleSettingClick = () => {
    setOpenSetting(true);
  };

  const SetBillNumber = () => {
    let BookCode = FormDataFromRedux?.MasterData?.[Form_Key]?.Voucher_Series;
    let NextNumber = FormData?.Bill_No;

    let ConCat = `${BookCode?.Prefix || ""}${NextNumber || ""}${BookCode?.Sufix || ""}`;

    updateSingleField(formRef, "Invoice_No", ConCat);
  };

  const handleCustomForm = (e) => {

    dispatch({
      type: "UNIQUE_TABLE_LIST",

      payload: {
        key: "Custom_Fields",
        data: {
          Selected_Rows: [e],
          Selected_Row: e,
          SelRow_id: [e?._id],
          SelRow_ids: [e?._id],
        },
      },
    });
    setcusFieldShow(true);
  };


  if (TypeOfPortal === "Delete") {
    return (
      <>
        <Confirm toggle={toggle} settoggle={settoggle} submit={submit} loadingState={SalesBillLoadingState} />
      </>
    );
  }

  if (TypeOfPortal === "Lock" || TypeOfPortal === "Unlock") {
    return (
      <>
        <Confirm
          submitType={`Confirm ${TypeOfPortal}`}
          submit={submit}
          settoggle={settoggle}
          toggle={toggle}
          loadingState={lockSalesBillLoading}
          message={`Are You Sure You Want to ${TypeOfPortal} this Record?`}
        />
      </>
    );
  }
  return (
    <>
      <div>
        <Reactportal
          open={toggle}
          onClose={Closeformfunction}
          TypeOfPortal={TypeOfPortal + " " + "Purchase Bill"}
          TypeOfId={"Account Id :"}
          Form_Key={Form_Key}
          AdditionalContent={() => {
            return (
              <span onClick={HandleSettingClick} className="settingIcon">
                {" "}
                <IoSettingsOutline className="settingIcon" />
              </span>
            );
          }}
        >
          <div className="SalesBillContainer">
            {SalesBillLoadingState && <div className="loader-line-div" />}
            <div className="">
              {InputFields.length ? (
                InputFields.map((e) => {
                  console.log(e.fields);
                  return (
                    <>
                      <div className="SalesBillContainer2">
                        <FormInputSectionComponent
                          TypeOfPortal={TypeOfPortal}
                          inputfields={e.fields}
                          onErrorsChange={handleErrorsChange}
                          onhandleFormikChange={HanldeChangeonForm}
                          Type={"Bill_Details"}
                          formkey={Form_Key}
                          setFirstLoad={setFirstLoad}
                          isFirstLoad={isFirstLoad}
                          formRef={formRef}
                          handleCustomForm={handleCustomForm}
                          FormData={FormData}
                        />
                      </div>
                    </>
                  );
                })
              ) : (
                <Loading />
              )}
            </div>
            <SalesItemTable
              Form_Key={Form_Key}
              tableData={tableData}
              setTableData={setTableData}
              lastModified={lastModified}
              setLastModified={setLastModified}
              setFirstLoad={setFirstLoad}
              isFirstLoad={isFirstLoad}
              FormData={FormData}
            />
            <div className="SalesBilltableContainer">
              <div className="NarrationAndDoc">
                <div>
                  <label>Narration:</label>
                  <textarea
                    name="Narration"
                    value={Note}
                    onChange={(e) => {
                      setNote(e.target.value);
                    }}
                  ></textarea>
                </div>
                <div>
                  <div>
                    {Purchase_Bill_Documents?.map((e) => {
                      return (
                        <div className="sales_documents_section">
                          <FormInputSectionComponent
                            TypeOfPortal={TypeOfPortal}
                            inputfields={e.fields}
                            onErrorsChange={handleErrorsChange}
                            onhandleFormikChange={HanldeChangeonForm}
                            Type={"Documents"}
                            formkey={Form_Key}
                            setFirstLoad={setFirstLoad}
                            isFirstLoad={isFirstLoad}
                            formRef={formRef}
                            FormData={FormData}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              <FormulaTable
                Form_Key={Form_Key}
                tableData={tableData}
                lastModified={lastModified}
                setLastModified={setLastModified}
                Formula={Formula}
                setFormula={setFormula}
                isFirstLoad={isFirstLoad}
                setRefRows={setRefRows}
                InvoiceType={"Purchase"}
                FormData={FormData}
                formRef={formRef}
                setFirstLoad={setFirstLoad}
                selectedOption={selectedOption}
                setSelectedOption={setSelectedOption}
              />
            </div>
          </div>

          <PortalFooter
            renderContent={() => (
              <>
                {Party?.Balance_Method === "Bill By Bill" || Party?.Balance_Method === true ? (
                  <>
                    <Button action={() => OpenReference()} name="modalbutton" text="Reference" />
                  </>
                ) : (
                  <></>
                )}
              </>
            )}
            disabled={false}
            submitform={() => Validate_handleSubmit(submit)}
            submitType={submitType}
            Form_key={Form_Key}
            SaveAndClose={() => {
              TypeOfPortal === "Add" ? Validate_handleSubmit(SaveAndCloseForAdd) : Validate_handleSubmit(submit);
            }}
            handleformclose={() => {
              Closeformfunction();
            }}
            loadingState={SalesBillLoadingState}
          />
        </Reactportal>
      </div>
      {openRef && (
        <ReferenceModal
          show={openRef}
          setModalToggle={() => setOpenRef(false)}
          transactionId={1}
          Amount={Total}
          Account_ID={Party?.Account_Balance_Id}
          query={NewReferencesOfAccount}
          Transaction_Type="Credit"
        />
      )}
      {OpenBookCodeSet && (
        <InvoiceNumberConfiguration
          show={OpenBookCodeSet}
          setOpenBookCodeSet={setOpenBookCodeSet}
          formRef={formRef}
          FormData={FormData}
          setFormData={setFormData}
          Form_Key={Form_Key}
          SetBillNumber={SetBillNumber}
          voucherNumberConfig={PurchaseInvoiceNumberConfig}
        />
      )}
      {openSetting && (
        <FormConfiguration
          show={openSetting}
          ParentClosingFunction={setOpenSetting}
          config={PurchaseBillConfiguration}
          HanldeChangeonForm={HanldeChangeonForm}
          formRef={formRef}
          setFirstLoad={setFirstLoad}
          allFieldsData={allFieldsData}
          getFormSectionAndFields={getFormSectionAndFields}
          formKey={Form_Key}
          forFormValues={FormData}
          ToGetDefaultValues={() => {
            getDefaultValues();
          }}
          preference={true}
        />
      )}
    </>
  );
};

export default AddPurchaseBill;
